export default __webpack_public_path__ + "static/media/schedule-3.726cd0bd.svg";